module.exports = __webpack_public_path__ + "img/cli-pen-alt.d2f2ee29.svg";